import {
  Alert,
  AppBar,
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  Checkbox,
  Chip,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Drawer,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  InputLabel,
  IconButton,
  LinearProgress,
  Link,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Modal,
  Pagination,
  Snackbar,
  Select,
  Stack,
  Stepper,
  Step,
  StepLabel,
  Tab,
  Tabs,
  Toolbar,
  Tooltip,
  TextField,
  Typography,
  useTheme,
  useMediaQuery,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@mui/material';

import { BarChart, LineChart, ScatterChart } from '@mui/x-charts';

const ButtonGroup = ({ children }) => {
  return (
    <Box display="flex" flexWrap="wrap" justifyContent="flex-end" gap={1}>
      {children}
    </Box>
  );
};

export {
  Alert,
  AppBar,
  BarChart,
  Box,
  Breadcrumbs,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  Checkbox,
  Chip,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Drawer,
  FormControl,
  FormControlLabel,
  Grid,
  Grid as Grid2,
  InputAdornment,
  InputLabel,
  IconButton,
  LineChart,
  LinearProgress,
  Link,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Menu,
  MenuItem,
  Modal,
  Pagination,
  ScatterChart,
  Select,
  Snackbar,
  Stack,
  Stepper,
  Step,
  StepLabel,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tab,
  Tabs,
  Tooltip,
  Toolbar,
  TextField,
  Typography,
  useTheme,
  useMediaQuery,
};
